function assignRoleToFlags() {
  // Select all elements with the class "flags"
  const flagElements = document.querySelectorAll(".flags");
  flagElements.forEach((element) => {
    element.setAttribute("role", "button");
    element.setAttribute("tabindex", 0);
  });

  console.log(`Assigned role="button" to ${flagElements.length} elements.`);
  const spanElement = document.querySelector("span.current.notranslate");

  if (spanElement) {
    // Add the desired attributes
    spanElement.setAttribute("role", "button");
    spanElement.setAttribute("tabindex", "0");
    console.log("Attributes added successfully!");
  } else {
    console.log("No matching span element found.");
  }
}

function assignRoleNoneToFigureCardMedia() {
  const elements = document.querySelectorAll("figure.card-media");
  elements.forEach((element) => {
    element.setAttribute("role", "none");
  });
  console.log(`Added role="none" to ${elements.length} <figure> elements.`);
}

function assignRoleNoneToFigureWidgetMedia() {
  const elements = document.querySelectorAll("figure.widget-media");
  elements.forEach((element) => {
    element.setAttribute("role", "none");
  });
  console.log(`Added role="none" to ${elements.length} <figure> elements.`);
}

function enhanceCurrentPageLink() {
  const links = document.querySelectorAll('a[aria-current="page"].current');
  links.forEach((link) => {
    link.setAttribute("aria-haspopup", "true");
    link.setAttribute("role", "button");
  });
  console.log(
    `Added aria-haspopup="true" and role="button" to ${links.length} <a> elements.`
  );
}

function addAriaLabelToMobileExpandButton() {
  const buttons = document.querySelectorAll(
    "button.navigation-mobile-item-link-expand"
  );
  buttons.forEach((button) => {
    button.setAttribute("aria-label", "Tap to expand menu");
  });
  console.log(
    `Added aria-label="Tap to expand menu" to ${buttons.length} <button> elements.`
  );
}

function addRolePresentationToSVG() {
  const svgs = document.querySelectorAll('svg[viewBox="0 0 24 24"]');
  svgs.forEach((svg) => {
    svg.setAttribute("role", "presentation");
  });
  console.log(`Added role="presentation" to ${svgs.length} <svg> elements.`);
  const svgs2 = document.querySelectorAll('svg[viewBox="0 0 48 48"]');
  console.log(
    `Found ${svgs2.length} <svg> elements with viewBox="0 0 48 48". Adding role="presentation".`
  );
  svgs2.forEach((svg) => {
    svg.setAttribute("role", "presentation");
  });
  console.log(`Added role="presentation" to ${svgs2.length} <svg> elements.`);
}

function addRoleToButtonSpan() {
  const buttons = document.querySelectorAll("span.rte");
  buttons.forEach((button) => {
    button.setAttribute("role", "button");
    button.setAttribute("tabindex", "0");
  });
  console.log(
    `Added role="button" to ${buttons.length} <span class="rte" elements>`
  );
}

function addRoleHeadingToPriceItems() {
  const priceItems = document.querySelectorAll(
    "span.price-item.price-item-regular"
  );
  priceItems.forEach((span) => {
    span.setAttribute("role", "heading");
  });
  console.log(`Added role="heading" to ${priceItems.length} <span> elements.`);
}

function addRolePresentationToStockDot() {
  const stockDots = document.querySelectorAll("span.badge-stock-dot");
  stockDots.forEach((span) => {
    span.setAttribute("role", "presentation");
  });
  console.log(
    `Added role="presentation" to ${stockDots.length} <span> elements.`
  );
}

function setAriaRequiredForEmailInputs() {
  const emailInputs = document.querySelectorAll('input[type="email"]');
  emailInputs.forEach((input) => {
    input.setAttribute("aria-required", "true");
  });
  console.log(
    `Set aria-required="true" on ${emailInputs.length} <input type="email"> elements.`
  );
}

function addRoleHeadingToPriceAndMoney() {
  const spans = document.querySelectorAll("span.price-item, span.money");
  spans.forEach((span) => {
    span.setAttribute("role", "heading");
  });
  console.log(`Added role="heading" to ${spans.length} <span> elements.`);
}

function addAriaHasPopupToLinksWithChildren() {
  const links = document.querySelectorAll("a");
  let count = 0;

  links.forEach((link) => {
    if (link.children.length > 0) {
      link.setAttribute("aria-haspopup", "true");
      count++;
    }
  });
  console.log(
    `Added aria-haspopup="true" to ${count} <a> elements with children.`
  );
}
function toggleAriaExpanded() {
  document.querySelectorAll(".icon.icon-angle").forEach((icon) => {
    let parent = icon.parentElement;
    if (parent) {
      parent.setAttribute("aria-expanded", "false");
      parent.addEventListener("click", function () {
        let isExpanded = this.getAttribute("aria-expanded") === "true";
        this.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      });
    }
  });
}

function setAngleFontSize() {
  const angleSpans = document.querySelectorAll("span.angle");
  angleSpans.forEach((span) => {
    span.style.fontSize = "2rem";
  });
  console.log(
    `Set font size to 2rem for ${angleSpans.length} <span> elements with class "angle".`
  );
}

function addRoleNoneToVisuallyHiddenSVG() {
  const svgs = document.querySelectorAll('svg.visually-hidden');
  svgs.forEach(svg => {
    svg.setAttribute('role', 'none');
  });
  console.log(`Added role="none" to ${svgs.length} <svg> elements with class "visually-hidden".`);
}

/*mutation observers to detect different changes on page, DO NOT REMOVE*/
const observer = new MutationObserver((mutationsList, observer) => {
  const appElement = document.querySelector(".flags-Zambia");
  if (appElement) {
    assignRoleToFlags();
    observer.disconnect(); // Stop observing once loaded
  }
});

const observer2 = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      console.log("New content detected. Running functions...");
      runAllFunctions();
    }
  }
});


// Function to run all the above functions
function runAllFunctions() {
  assignRoleNoneToFigureCardMedia();
  enhanceCurrentPageLink();
  addAriaLabelToMobileExpandButton();
  addRolePresentationToSVG();
  addRoleToButtonSpan();
  addRoleHeadingToPriceItems();
  addRolePresentationToStockDot();
  assignRoleNoneToFigureWidgetMedia();
  setAriaRequiredForEmailInputs();
  addRoleHeadingToPriceAndMoney();
  addAriaHasPopupToLinksWithChildren();
  toggleAriaExpanded();
  setAngleFontSize();
  addRoleNoneToVisuallyHiddenSVG();
}

observer.observe(document.body, { childList: true, subtree: true });
observer2.observe(document.body, { childList: true, subtree: true });
runAllFunctions();
